// extracted by mini-css-extract-plugin
export var colorSquare = "_qk-0";
export var danger = "_qk-5";
export var lightPink = "_qk-8";
export var neutralBlue = "_qk-7";
export var neutralYellow = "_qk-6";
export var normal = "_qk-1";
export var primary = "_qk-2";
export var primaryLight = "_qk-3";
export var solidBlack = "_qk-g";
export var solidGreen = "_qk-b";
export var solidLightBlue = "_qk-d";
export var solidNavy = "_qk-c";
export var solidOrange = "_qk-f";
export var solidPink = "_qk-e";
export var solidRed = "_qk-9";
export var solidYellow = "_qk-a";
export var success = "_qk-4";